import React from 'react'
import "./error500.css"
import { MdClose } from "react-icons/md";
import { Link } from 'react-router-dom';

const Error500 = (props) => {
  return (
    <div className="modal_bg">
    <div class="modal-dialog modal-confirm" data-aos="fade-down" data-aos-duration="500">
		<div class="modal-content">
			<div class="modal-header justify-content-center">
				<div class="icon-box">
          <MdClose/>
				</div>
				<button onClick={()=>props.setShowError(false)} type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
			</div>
			<div class="modal-body text-center">
				<h2>500</h2>	
				<h4>Internal server error!</h4>	
				<p>We are currently trying to fix the problem.</p>
				<Link to="/" class="btn error500-btn" data-dismiss="modal">Home</Link>
			</div>
		</div>
	</div>
    </div>
  )
}

export default Error500